import React from 'react';
import styled from 'styled-components';
const RotateContainer = styled.div`
  position: fixed;
  transform: rotate(180deg);
  right: 0;
  top: 0;
  display: block;
  height: 100vh;
  writing-mode: vertical-rl;
  margin: auto -30px;
  z-index: -10;
  @media (max-width: 768px) {
    display: none;
  }
`;
const SidetextContainer = styled.h1`
  font-size: 12vh;
  text-align: start;
  color: var(--color-tertiary);
  user-select: none;

  margin: 0;
`;
const SideText = ({ text }) => {
  return (
    <RotateContainer>
      <SidetextContainer>{text}</SidetextContainer>
    </RotateContainer>
  );
};

export default SideText;
